import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { each, map, uniq, camelCase, cloneDeep, find } from 'lodash';
import { Dropdown, MenuItem } from 'react-bootstrap';
import styles from './opportunity-graphs.css';
import DropdownRange from '../../../../components/dropdown-range';
import Pie from './pie';
import { format as formatMoney } from '../../../../components/money-display';

import { getHasNoDecisionSetup } from '../../../../components/search-form/search-form-reducer';
// Import Selectors
import { getOpportunities, getLoaded, getLoading } from '../../AnalysisReducer';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';

export function getDefautlIndexFromTotal(total) {
  const lowerIndex = Math.floor((total / 3) - 1);
  const upperIndex = Math.floor((2 * (total / 3)) - 1);
  return [lowerIndex, upperIndex];
}

export function getAmountIndexFromBuckets(buckets = []) {
  return uniq(map(buckets, item => Math.round(item.amount * 100) / 100));
}

export function getBreakDownBuckets(buckets, amountIndex, minIndex, maxIndex) {
  const lowerAmount = amountIndex[minIndex];
  const upperAmount = amountIndex[maxIndex];

  const oneStat = {
    total: 0,
    amount: 0,
    min: null,
    max: 0,
    stats: {
      won: { total: 0, amount: 0, opportunityIds: [] },
      lost: { total: 0, amount: 0, opportunityIds: [] },
      noDecision: { total: 0, amount: 0, opportunityIds: [] },
    },
  };

  const results = {
    large: cloneDeep(oneStat),
    medium: cloneDeep(oneStat),
    small: cloneDeep(oneStat),
    total: cloneDeep(oneStat),
  };
  each(buckets, (item) => {
    let bucketType = 'medium';
    if (item.amount <= lowerAmount) {
      bucketType = 'small';
    } else if (item.amount >= upperAmount) {
      bucketType = 'large';
    }
    each([bucketType, 'total'], (type) => {
      const bucket = results[type];
      const stage = camelCase(item.stage);
      if (bucket.stats[stage]) {
        bucket.amount += item.amount;
        bucket.max = Math.max(bucket.max, item.amount);
        if (bucket.min === null) {
          bucket.min = item.amount;
        } else {
          bucket.min = Math.min(bucket.min, item.amount);
        }
        bucket.total += 1;
        bucket.stats[stage].total += 1;
        bucket.stats[stage].amount += item.amount || 0;
        bucket.stats[stage].opportunityIds.push(item.opportunity_id);
      }
    });
  });
  return results;
}

const USER_PREFERENCE_REPORT_TYPE = 'outcomes-size-graph-report-type';

class OpportunityGraphs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: 'amount',
      amountIndex: [],
      bounds: [0, 0],
    };
    this.onSliderChange = this.onSliderChange.bind(this);
    this.setReportType = this.setReportType.bind(this);
    this.decrease = this.decrease.bind(this);
    this.increase = this.increase.bind(this);
  }

  componentWillMount() {
    const { buckets } = this.props;
    const { userPreferences } = this.context;
    const reportType = userPreferences[USER_PREFERENCE_REPORT_TYPE] || 'amount';
    const amountIndex = getAmountIndexFromBuckets(buckets);
    const total = amountIndex.length;
    const bounds = getDefautlIndexFromTotal(total);
    this.setState({ reportType, amountIndex, bounds });
  }

  onSliderChange(bounds) {
    this.setState({ bounds });
    this.props.onBoundChange(bounds);
  }

  getBounds() {
    const { amountIndex, bounds } = this.state;
    const total = amountIndex.length;
    const defaultIndex = getDefautlIndexFromTotal(total);
    const lowerIndex = bounds[0] !== null && bounds[0] < total ? bounds[0] : defaultIndex[0];
    const upperIndex = bounds[1] !== null && bounds[1] < total ? bounds[1] : defaultIndex[1];
    return [lowerIndex, upperIndex];
  }

  setReportType(reportType) {
    this.setState({ reportType });
    this.context.updateUserPreference(USER_PREFERENCE_REPORT_TYPE, reportType);
  }

  getBucketSubTitle(bucket) {
    const { organization } = this.props;
    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }
    const min = formatMoney(bucket.min, true, 1, symbol);
    const max = formatMoney(bucket.max, true, 1, symbol, suffix);
    return `${min} - ${max}`;
  }

  getBucketTitle(title, bucket) {
    const titleSuffix = `DEAL${(bucket.total !== 1 ? 'S' : '')}`;
    return `${title} ${titleSuffix}`;
  }
  decrease() {
    const currentBounds = this.getBounds();
    const lowerBound = currentBounds[0];
    const upperBound = currentBounds[1];
    const newLowerBound = Math.max(0, lowerBound - 1);
    const bounds = [newLowerBound, upperBound];
    this.setState({ bounds });
  }

  increase() {
    const { amountIndex } = this.state;
    const currentBounds = this.getBounds();
    const lowerBound = currentBounds[0];
    const upperBound = currentBounds[1];
    const newUpperBound = Math.min(upperBound + 1, amountIndex.length - 1);
    const bounds = [lowerBound, newUpperBound];
    this.setState({ bounds });
  }
  render() {
    const {
      loaded, loading, hasNoDecisionSetup, organization,
    } = this.props;
    if (!loaded || loading) {
      return null;
    }
    const { reportType, amountIndex } = this.state;
    const bounds = this.getBounds();
    const buckets = getBreakDownBuckets(this.props.buckets, amountIndex, bounds[0], bounds[1]);
    let fieldSuffix = '';
    let fieldPrefix = '';
    if (organization) {
      fieldSuffix = organization.currency_suffix;
      fieldPrefix = organization.currency_symbol;
    }


    const reportTypes = [
      { value: 'amount', label: 'Amount' },
      { value: 'count', label: 'Count' },
    ];
    const activeReportType = find(reportTypes, { value: reportType }) || { label: 'Amount' };
    return (
      <div className={`${styles.opportunityGraphs} opportunity-graphs`}>
        <div className="animated fadeIn">
          <div>
            <h5 className="sub-header-with-controls">
              <Dropdown
                id="bucket-report-type-dropdown"
              >
                <Dropdown.Toggle bsSize="small">
                  {activeReportType.label}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {reportTypes.map(s => (
                    <MenuItem
                      key={s.value}
                      active={s.value === reportType}
                      onSelect={() => { this.setReportType(s.value); }}
                    >
                      {s.label}
                    </MenuItem>
                    ))}
                </Dropdown.Menu>
              </Dropdown>
              &nbsp;
              <span>outcome rates in small, medium, and large deal sizes with boundaries</span>
              &nbsp;
              {buckets.total.total && <DropdownRange
                values={amountIndex}
                bounds={bounds}
                onSliderChange={this.onSliderChange}
                modalProps={{
                  fieldPrefix,
                  fieldSuffix,
                  title: 'Small, Medium and Large Deal Size Boundaries',
                  lowerLabel: 'Medium Size Start',
                  upperLabel: 'Large Size Start',
                }}
              />}
            </h5>
            <div className="row">
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.small}
                  type="small"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.small)}
                  title={this.getBucketTitle('SMALL', buckets.small)}
                  onChartSegmentSelect={this.props.onChartSegmentSelect}
                />
              </div>
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.medium}
                  type="medium"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.medium)}
                  title={this.getBucketTitle('MEDIUM', buckets.medium)}
                  onChartSegmentSelect={this.props.onChartSegmentSelect}
                />
              </div>
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.large}
                  type="large"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.large)}
                  title={this.getBucketTitle('LARGE', buckets.large)}
                  onChartSegmentSelect={this.props.onChartSegmentSelect}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OpportunityGraphs.propTypes = {
  buckets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onBoundChange: PropTypes.func,
  loaded: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  hasNoDecisionSetup: PropTypes.bool.isRequired,
  organization: PropTypes.shape({}),
  onChartSegmentSelect: PropTypes.func,
};

OpportunityGraphs.defaultProps = {
  onBoundChange: () => {},
  organization: null,
  onChartSegmentSelect: () => {},
};
OpportunityGraphs.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.object.isRequired,
};

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    buckets: getOpportunities(state),
    loaded: getLoaded(state),
    loading: getLoading(state),
    hasNoDecisionSetup: getHasNoDecisionSetup(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps)(OpportunityGraphs);
